<template>
  <div v-if="isReady" id="overviewBackground" class="main-overview">
    <platform-navigation class="main-nav"></platform-navigation>
    <router-view class="main-overview__body"></router-view>
  </div>
</template>

<script>
import PlatformNavigation from "@/components/_Navigation/PlatformNavigation.vue";
import { app, db } from "@/firebase";
import Vue from "vue";

export default {
  components: {
    PlatformNavigation,
  },
  data() {
    return {
      isReady: false,
    };
  },
  created() {
    if (!this.$route.params.hotel) {
      throw Error("No hotel specified");
    }

    return this.initialize();
  },
  methods: {
    updateLastLogin(userId, date) {
      return db.ref("/users/" + userId).update({
        lastLoginDate: date.toJSON().slice(0, 10).replace(/-/g, "/"),
      });
    },
    getCustomerID(userId) {
      return db.ref(`/users/${userId}/customerid`)
        .once('value')
        .then(snapshot => snapshot.val());
    },
    isSingleLanguage(customerID) {
      return db.ref(`customers/${customerID}/languageTypes`)
        .once('value')
        .then(snapshot => {
            return snapshot.val().length == 1 
        });
    },
    firstLanguage(customerID) {
      return db
        .ref(`customers/${customerID}/languageTypes`)
        .once("value")
        .then((snapshot) => snapshot.val()[0]);
    },
    secondLanguage(customerID) {
      return db
        .ref(`customers/${customerID}/languageTypes`)
        .once("value")
        .then((snapshot) => snapshot.val()[1]);
    },
    hotelLocationInitals(customerID) {
      return db
        .ref(`customers/${customerID}/language`)
        .once("value")
        .then((snapshot) => snapshot.val());
    },
    // todo: replace with Object.fromEntries when upgraded to node 12
    objectFromEntries(entries) {
      return entries.reduce(
        (acc, [key, value]) => ({ ...acc, [key]: value }),
        {}
      );
    },
    loadConfiguration(hotelID, customerID) {
      const keyBy = (key) => (value) => [key, value];

      const configPromises = [
        this.isSingleLanguage(customerID).then(keyBy("$isSingleLanguage")),
        this.firstLanguage(customerID).then(keyBy("$settingsDefaultLanguageType")),
        this.secondLanguage(customerID).then(keyBy("$settingsSecondLanguageType")),
        this.hotelLocationInitals(customerID).then(keyBy("$hotelLocationInitals")),
      ];

      return Promise.all(configPromises).then((config) =>
        this.objectFromEntries(config)
      );
    },
    async initialize() {
      const user = app.auth().currentUser;
      if (user) {
        Vue.prototype.$userId = user.uid;

        await this.updateLastLogin(user.uid, new Date());

        Vue.prototype.$hotelId = this.$route.params.hotel;
        Vue.prototype.$customerId = await this.getCustomerID(user.uid);

        Object.assign(Vue.prototype, await this.loadConfiguration(this.$hotelId, this.$customerId));

        this.isReady = true;
      }
    },
  },
};
</script>

<style scoped>
.main-overview {
  height: 100%;
}
</style>
